module.exports = __webpack_public_path__ + "img/pt.71227e0c.svg";